import {newFolder} from '../actions/library/folders'

export function createFolder(parentFolder,folderName,repoId) {
	var nowDate = new Date()
	const requestBody={
		'name':folderName,
		'parent':parentFolder,
		'clientModified':nowDate,
		'userCreated':nowDate,
		 'archived': false,
		 'repo':repoId
	}
	return newFolder(requestBody)
}


// WEBPACK FOOTER //
// ./src/utils/createFolder.js